import { render, staticRenderFns } from "./top.vue?vue&type=template&id=21eb883f&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=21eb883f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eb883f",
  null
  
)

export default component.exports